import type { NitroFetchOptions, NitroFetchRequest } from "nitropack";
import { useAPIBaseUrl } from "@composables/useAPIBaseUrl.ts";

export const environmentAwareFetch = async <T>(
	url: string,
	options?: NitroFetchOptions<NitroFetchRequest>
): Promise<T> => {

	const baseURL = useAPIBaseUrl();
	return await $fetch<T>(url, {
		baseURL,
		...options
	});
};